/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosInstance } from 'axios';

const baseUrl = `/api/internal/sessions`;

export namespace SessionAPI {
  export interface Session {
    id: string;
    videoAccessToken: string;
    callId: string;
    updatedAt: Date;
    createdAt: Date;
  }
}

export const sessionsClient = (request: AxiosInstance) => ({
  async fetchSession(): Promise<SessionAPI.Session> {
    return (await request.get(`${baseUrl}`)).data;
  },
});
